import { RepairPayablesSheet } from './views';

export default {
  list: RepairPayablesSheet,
  name: 'repair-payables-sheet',
  label: 'Repairs - Payable',
  to: '/repair-payables-sheet',
};
